/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 2/11/2023
 */

//generate permissions for all, client, resource, scheduler, journal, session, member and for actions: access full, assign, assign self, read, write, create, update, delete
export const PermissionsEnum = Object.freeze({

	ALL_ACCESS_FULL: 		'all_access_full',
	ALL_ASSIGN: 			'all_assign',
	ALL_ASSIGN_SELF: 		'all_assign_self',
	ALL_READ: 				'all_read',
	ALL_WRITE: 				'all_write',

	CLIENT_SCOPE_ALL: 		'client_scope_all',
	RESOURCE_SCOPE_ALL: 	'resource_scope_all',
	SCHEDULER_SCOPE_ALL: 	'scheduler_scope_all',
	JOURNAL_SCOPE_ALL: 		'journal_scope_all',
	SESSION_SCOPE_ALL: 		'session_scope_all',
	MEMBER_SCOPE_ALL: 		'member_scope_all',
	LEGALDOC_COMPLETED_SCOPE_ALL: 'legaldoc_completed_scope_all',
	FORM_COMPLETED_SCOPE_ALL: 'form_completed_scope_all',


	CLIENT_ACCESS: 			'client_access_full',
	CLIENT_ASSIGN: 			'client_assign',
	CLIENT_ASSIGN_SELF: 	'client_assign_self',
	CLIENT_READ: 			'client_read',
	CLIENT_WRITE: 			'client_write',
	CLIENT_CREATE: 			'client_create',
	CLIENT_UPDATE: 			'client_update',
	CLIENT_DELETE: 			'client_delete',

	RESOURCE_ACCESS: 		'resource_access_full',
	RESOURCE_ASSIGN: 		'resource_assign',
	RESOURCE_ASSIGN_SELF: 	'resource_assign_self',
	RESOURCE_READ: 			'resource_read',
	RESOURCE_WRITE: 		'resource_write',
	RESOURCE_CREATE: 		'resource_create',
	RESOURCE_UPDATE: 		'resource_update',
	RESOURCE_DELETE: 		'resource_delete',

	SCHEDULER_ACCESS: 		'scheduler_access_full',
	SCHEDULER_ASSIGN: 		'scheduler_assign',
	SCHEDULER_ASSIGN_SELF: 	'scheduler_assign_self',
	SCHEDULER_READ: 		'scheduler_read',
	SCHEDULER_WRITE: 		'scheduler_write',
	SCHEDULER_CREATE: 		'scheduler_create',
	SCHEDULER_UPDATE: 		'scheduler_update',
	SCHEDULER_DELETE: 		'scheduler_delete',

	JOURNAL_ACCESS: 		'journal_access_full',
	JOURNAL_ASSIGN: 		'journal_assign',
	JOURNAL_ASSIGN_SELF: 	'journal_assign_self',
	JOURNAL_READ: 			'journal_read',
	JOURNAL_WRITE: 			'journal_write',
	JOURNAL_CREATE: 		'journal_create',
	JOURNAL_UPDATE: 		'journal_update',
	JOURNAL_DELETE: 		'journal_delete',

	SESSION_ACCESS: 		'session_access_full',
	SESSION_ASSIGN: 		'session_assign',
	SESSION_ASSIGN_SELF: 	'session_assign_self',
	SESSION_READ: 			'session_read',
	SESSION_WRITE: 			'session_write',
	SESSION_CREATE: 		'session_create',
	SESSION_UPDATE: 		'session_update',
	SESSION_DELETE: 		'session_delete',

	MEMBER_ACCESS: 			'member_access_full',
	MEMBER_ASSIGN: 			'member_assign',
	MEMBER_ASSIGN_SELF: 	'member_assign_self',
	MEMBER_READ: 			'member_read',
	MEMBER_WRITE: 			'member_write',
	MEMBER_CREATE: 			'member_create',
	MEMBER_UPDATE: 			'member_update',
	MEMBER_DELETE: 			'member_delete',


})

export const AccessScopeEnum = Object.freeze({
	ALL: 			  200,
	ASSIGNED_ENTRIES: 100,
})

export const ClientScopeAll = "client_scope_all"
export const ResourceScopeAll = "resource_scope_all"
export const SchedulerScopeAll = "scheduler_scope_all"
export const JournalScopeAll = "journal_scope_all"



export const ScopeFullObj = {label: "All entries", value: AccessScopeEnum.ALL, tooltip: "'All entries' gives access to all entries as opposite to handpicking and assigning each entry manually."}
export const ScopeAssignedOnlyObj = {label: "Assigned entries only", value: AccessScopeEnum.ASSIGNED_ENTRIES, tooltip: "'Assigned entries only' scope allows you handpick and assign specific entries to this team member."}

export const ScopeObjArray = [
	ScopeFullObj,
	ScopeAssignedOnlyObj
]












